<template>
  <div>
    <v-flex xs12 sm12 md12>
      <Filters />
    </v-flex>
    <v-flex xs12 sm12 md12 class="align-content-end">
      <Balance />
    </v-flex>
    <v-flex xs12 sm12 md12>
      <v-container grid-list-md fluid>
        <v-layout row>
          <v-flex xs12 sm12 md12>
            <Operations />
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
  </div>
</template>
<script>
import Filters from "../components/extrato/Filters";
import Balance from "../components/extrato/Balance";
import Operations from "../components/extrato/Operations";
export default {
  components: {
    Filters,
    Balance,
    Operations,
  },
};
</script>
